import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { CheckboxList } from "@platform/design-system";

import { COVERAGE_LABEL_FIELD } from "./types";

import type { CustomToolPanelProps } from "ag-grid-react";

const PINNED_FIELDS = new Set<string>([COVERAGE_LABEL_FIELD]);

export const CarriersPanel = ({
  api,
}: CustomToolPanelProps): React.JSX.Element => {
  const [, rerender] = useState(0);

  useEffect(() => {
    const handler = (): void => rerender((n) => n + 1);

    api.addEventListener("columnVisible", handler);

    return () => api.removeEventListener("columnVisible", handler);
  }, [api]);

  const items = (api.getColumns() ?? [])
    .filter((col) => {
      const field = col.getColDef().field;
      return field != null && !PINNED_FIELDS.has(field);
    })
    .map((col) => ({
      id: col.getColId(),
      label: col.getColDef().headerName ?? col.getColId(),
      checked: col.isVisible(),
    }));

  const handleToggle = (colId: string): void => {
    const col = api.getColumn(colId);
    if (col) api.setColumnsVisible([colId], !col.isVisible());
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <CheckboxList items={items} onToggle={handleToggle} />
      </Box>
    </Box>
  );
};
